import React, { useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DeviceContext = /*#__PURE__*/React.createContext({
  isMobileDevice: false
});
export const useDevice = () => useContext(DeviceContext);
export const DeviceProvider = _ref => {
  let {
    children,
    value
  } = _ref;
  return /*#__PURE__*/_jsx(DeviceContext.Provider, {
    value: value,
    children: children
  });
};